import { render, staticRenderFns } from "./CurrentZipEditor.vue?vue&type=template&id=22bb6be8&scoped=true&"
import script from "./CurrentZipEditor.vue?vue&type=script&lang=js&"
export * from "./CurrentZipEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bb6be8",
  null
  
)

export default component.exports